export default __webpack_public_path__ + "static/media/momentjs.7d61d80e.svg";